{
  "names": {
    "Fajr": "Asuba",
    "Dhuhr": "Azahar",
    "Asr": "La'asar",
    "Maghrib": "Magariba",
    "Isha": "Isha'i"
  },
  "card": {
    "label": "Sallah ta gaba",
    "labelTomorrow": "Gobe · {{prayer}}",
    "inHoursMinutes": "cikin {{hours}}h {{minutes}}m",
    "inMinutes": "cikin {{minutes}}m",
    "open_aria": "Buɗe lokutan sallah",
    "pro": "Rhemn Pro",
    "unlock_aria": "Buɗe lokutan sallah da Rhemn Pro",
    "unavailable": "Lokutan sallah ba sa samuwa a yanzu."
  },
  "sheet": {
    "bellOn_aria": "Kashe tunatarwar {{prayer}}",
    "bellOff_aria": "Kunna tunatarwar {{prayer}}",
    "explainer": "Karɓi tunatarwa mai laushi a kowace sallah. Tunatarwa sanarwa ce shiru — babu sauti ta asali.",
    "enableReminders": "Kunna tunatarwa",
    "enableInSettings": "Kunna sanarwar Rhemn a cikin Saituna don karɓar tunatarwar sallah.",
    "openSettings": "Buɗe Saituna"
  },
  "notifications": {
    "body": "Lokacin sallah ya yi."
  },
  "focus": {
    "label": "Sallar {{prayer}}",
    "close_aria": "Rufe allon sallah",
    "hint": "Danna Esc ko × don dawowa",
    "phrases": {
      "accepted": "Allah ya karɓi sallarka",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Fara da niyya. Ci gaba da albarka.",
    "prayerApproaches": "Sallarka ta gaba tana gabatowa. Kasance da niyyarka.",
    "morningPursue": "Safiya mai albarka don biɗa: {{focus}}",
    "dayCloses": "Yayin da rana ke ƙarewa, yi tunani a kan: {{focus}}",
    "fulfilled": "Ka cika niyyarka a yau. Alhamdulillah.",
    "workingTowards": "A yau kana aiki zuwa ga: {{focus}}",
    "prayerNear": "Sallarka ta gaba tana kusa. Ɗauki numfashi."
  },
  "widget": {
    "countdown": "cikin {{time}}",
    "openToUpdate": "Buɗe Rhemn don sabuntawa",
    "openForVerse": "Buɗe Rhemn don ayar yau"
  }
}
